import { call, put, select } from 'redux-saga/effects';
import { list as crudList, get as crudGet, update as crudUpdate, create as crudCreate, remove as crudRemove, upsert as crudUpsert, multiUpsert as crudMultiUpsert, } from '../../crudInterface/crud';
import Operations from '../../crudInterface/operations';
import Features from '../../crudInterface/features';
export function* list(action) {
    try {
        const { featureName, payload, replace, sortArgument, pageIndex, reverseOrder } = action.payload;
        const state = yield select();
        const response = yield call(crudList, state[Features.TOKEN], featureName, payload, sortArgument, pageIndex);
        yield put({ type: featureName, operation: Operations.LIST, payload: response, replace, reverseOrder });
    }
    catch (error) {
        console.log(error);
        yield false;
    }
}
export function* get(action) {
    try {
        const { featureName, replace, reverseOrder } = action.payload;
        const state = yield select();
        const response = yield call(crudGet, state[Features.TOKEN], featureName);
        yield put({ type: featureName, operation: Operations.GET, payload: response, replace, reverseOrder });
    }
    catch (error) {
        console.log(error);
        yield false;
    }
}
export function* create(action) {
    try {
        const { featureName, replace, reverseOrder, payload } = action.payload;
        const state = yield select();
        const response = yield call(crudCreate, state[Features.TOKEN], featureName, payload);
        yield put({ type: featureName, operation: Operations.CREATE, payload: response, replace, reverseOrder });
    }
    catch (error) {
        console.log(error);
        yield false;
    }
}
export function* update(action) {
    try {
        const { featureName, replace, reverseOrder, payload } = action.payload;
        const state = yield select();
        const response = yield call(crudUpdate, state[Features.TOKEN], featureName, payload);
        yield put({ type: featureName, operation: Operations.UPDATE, payload: response, replace, reverseOrder });
    }
    catch (error) {
        console.log(error);
        yield false;
    }
}
export function* upsert(action) {
    try {
        const { featureName, replace, reverseOrder, payload } = action.payload;
        const state = yield select();
        const response = yield call(crudUpsert, state[Features.TOKEN], featureName, payload);
        if (response)
            yield put({ type: featureName, operation: Operations.UPSERT, payload: response, replace, reverseOrder });
    }
    catch (error) {
        console.log(error);
        yield false;
    }
}
export function* multiUpsert(action) {
    try {
        const { featureName, payload, replace, reverseOrder } = action.payload;
        const state = yield select();
        const response = yield call(crudMultiUpsert, state[Features.TOKEN], featureName, payload);
        if (response)
            yield put({ type: featureName, operation: Operations.MULTI_UPSERT, payload: response, replace, reverseOrder });
    }
    catch (error) {
        console.log(error);
        yield false;
    }
}
export function* remove(action) {
    try {
        const { featureName, payload } = action.payload;
        const state = yield select();
        const response = yield call(crudRemove, state[Features.TOKEN], featureName, payload);
        yield put({ type: featureName, operation: Operations.DELETE, payload: response });
    }
    catch (error) {
        console.log(error);
        yield false;
    }
}
